import React from 'react'
import BackToTop from '../Components/Backtotop'
import { HashLink } from 'react-router-hash-link'

function Footer() {
  return (
    <div>

        {/*--Footer Section start--*/}
        <footer className="pt-9 text-center text-white position-relative z-1 mt-10">
            <div className="overlay z-n1 start-0"></div>
            <div className="container">
            <div className="footer-content w-lg-50 m-auto">
                <div className="footer-logo mb-4 pt-1">
                <HashLink smooth to="#"><img src="assets/images/logo/2.svg" className="w-50" alt="footer-logo"/></HashLink>
                </div>
                <div className="footer-disciption border-bottom border-white border-opacity-25 m-auto mb-6 mt-10">
                <p className=" mb-6">Meet, Talk, Connect - Wydarzenia, które pracują dla Twojej marki.</p>
                <p className="mb-6" style={{fontSize:"12px"}}>NIP: 527 316 22 18<span style={{marginLeft:"30px", marginRight:"30px"}}>KRS: 0001169834</span>  REGON: 541591344</p>
                </div>
                <div className="footer-menu pb-9">
                <ul className="p-0 m-0">
                    <li className="d-inline mx-2"><HashLink smooth to="#"><small>STRONA GŁÓWNA</small></HashLink></li>
                    <li className="d-inline mx-2"><HashLink smooth to="#offer"><small>OFERTA</small></HashLink></li>
                    <li className="d-inline mx-2"><HashLink smooth to="#why-us"><small>DLACZEGO MY?</small></HashLink></li>
                    <li className="d-inline mx-2"><HashLink smooth to="#opinions"><small>OPINIE</small></HashLink></li>
                </ul>
                </div>
            </div>
            <div className="copyright pb-6 pt-1">
                <small>Copyright {new Date().getFullYear()} Eventen. All Rights Reserved Copyright</small>
            </div>
            </div>
        </footer>
        {/*--Footer Section end--*/}

        {/*--Bacl-to-top Button start--*/}
        <BackToTop />
        {/*--Bacl-to-top Button end--*/}
    </div>
  )
}

export default Footer